export default __webpack_public_path__ + "static/media/2.8c7126b4.png";